import { render } from "./AccountEmail.vue?vue&type=template&id=af1b6706&scoped=true&ts=true"
import script from "./AccountEmail.vue?vue&type=script&lang=ts"
export * from "./AccountEmail.vue?vue&type=script&lang=ts"

import "./AccountEmail.vue?vue&type=style&index=0&id=af1b6706&scoped=true&lang=scss"

import exportComponent from "/home/vsts/work/1/s/src/CRM/OutlookAddin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af1b6706"]])

export default __exports__